import React from "react";
import {BaseSearchableService} from "./Core/BaseSearchableService";
import {service as SampleEventPhaseService} from "./SampleEventPhaseService";
import {service as SampleEventTypeService} from "./SampleEventTypeService";
import {service as ProcedureService} from "./ProcedureService";
import {ContextNodesTableColumn} from "../Components/Common/FileBrowser/ContextNodesTableColumn";
import {ServiceDrivenTableColumn} from "../Components/Common/FileBrowser/ServiceDrivenTableColumn";
import {DateTableColumn} from "../Components/Common/Tables/DateTableColumn";
import {IconTableColumn} from "../Components/Common/Tables/IconTableColumn";
import {StreamBankLink} from "../Components/Common/StreamBankLink";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {FulcrumIcon} from "../Models/Core/FieldViewers/FulcrumRecordFieldViewer";

class SampleEventService extends BaseSearchableService {
    get Url() { return super.Url + "/sampleEvents"; }
    get ModelName() { return "Event"; }
    get PrimaryKeyProperty() { return "sampleEventId"; }
    get TitleProperty() { return "name"; }

    // get PageUrl() { return "/organizations"; }
    get ItemNamePlural() { return "events" }
    get CreatePermission() { return "create_sample_event" }
    get UpdatePermission() { return "update_sample_event" }
    // get Model() { return new SampleEvent() }

	GetTitle(model, defaultTitle = "") {
        const sampleEventType = SampleEventTypeService.CachedValueById(model.sampleEventTypeId)?.result;
        const sampleEventPhase = SampleEventPhaseService.CachedValueById(model.sampleEventPhaseId)?.result;
        const procedure = ProcedureService.CachedValueById(model.procedureId)?.result;

        if(sampleEventType?.code === 'monitoring') {
            return `${sampleEventPhase.name} ${procedure.name}`;
        }
        else if(sampleEventType?.code === 'modeling') {

            return `${sampleEventType.name}`;
        }
        return defaultTitle;
    }

    SampleEventReportIsSupported(sampleEvent) {
        return sampleEvent?.procedureId === 8;
    }

    SampleEventReportURL(sampleEvent) {
        if(this.SampleEventReportIsSupported(sampleEvent)) {
            return "/reportBuilder?" + (new URLSearchParams({
                monitoringEventId: sampleEvent?.sampleEventId,
                projectId: sampleEvent?.ConservationActionSampleEvents?.[0]?.ConservationAction?.projectId,
                procedureId: sampleEvent?.procedureId,
                reportTypeId: 4,
            }).toString());
        }

        return null;
    }

    get TableColumns() {
        return [
            {
                title: "Conservation Action",
                key: "ConservationAction",
                sortable: true,
                logic: (x) => x?.ConservationActionSampleEvents?.map(x => x.ConservationAction?.ContextNodeDetails),
                sortLogic: (x) => {
                    let contextNode = x?.ConservationActionSampleEvents?.map(x => x.ConservationAction?.ContextNodeDetails)?.find(x => x?.contextNodeId);
                    return contextNode?.title ?? contextNode.shortName
                },
                renderer: ContextNodesTableColumn
            },
            {
                title: "Type",
                key: "sampleEventTypeId",
                sortable: true,
                logic: (x) => x.sampleEventTypeId,
                renderer: ServiceDrivenTableColumn(SampleEventTypeService)
            },
            {
                title: "Phase",
                key: "sampleEventPhaseId",
                sortable: true,
                logic: (x) => x.sampleEventPhaseId,
                renderer: ServiceDrivenTableColumn(SampleEventPhaseService)
            },
            {
                title: "Procedure",
                key: "procedureId",
                sortable: true,
                logic: (x) => x.procedureId,
                sortLogic: (x) => ProcedureService.CachedTitleById(x?.procedureId),
                renderer: ServiceDrivenTableColumn(ProcedureService)
            },
            {
                title: "Start Date",
                key: "startDate",
                sortable: true,
                logic: (x) => x.startDate,
                renderer: DateTableColumn
            },
            // {
            //     title: "Scheduled",
            //     key: "scheduled",
            //     cellClassName: "cell-with-spaced-content",
            //     headerClassName: "cell-with-spaced-content",
            //     sortable: true,
            //     logic: this.eventIsScheduled,
            //     sortLogic: (x) => this.eventIsScheduled(x) ? 1 : 0,
            //     renderer: IconTableColumn(['fas', 'calendar'])
            // },
            {
                title: "Actions",
                key: "_actions",
                cellClassName: "actions-cell",
                headerClassName: "actions-cell",
                sortable: true,
                logic: (x) => x,
                renderer: ({rowData}) => <span className="actions">
                    {
                        this.SampleEventReportIsSupported(rowData) ?
                        <StreamBankLink
                            className={`btn-link link-primary pr-3 ${!this.SampleEventReportIsSupported(rowData) ? 'disabled' : ''}`}
                            Href={this.SampleEventReportURL(rowData)}
                        >
                            <FontAwesomeIcon icon={['fas', 'file-chart-line']} /> Run Report
                        </StreamBankLink> : <div/>
                    }
                    <StreamBankLink
                        className={`link-primary`}
                        Context={
                            rowData?.ConservationActionSampleEvents?.[0]?.ConservationAction?.ContextNodeDetails?.link
                            + '/' + rowData.sampleEventId
                        }
                        Tool="summary"
                    >
                        <FontAwesomeIcon icon={['fas', 'eye']} /> View
                    </StreamBankLink>
                    {rowData.fulcrumId && <>
                        <a
                            className="link-primary ml-3"
                            href={`https://web.fulcrumapp.com/records/${rowData.fulcrumId}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <span className="fa-layers fa-fw" style={{color: 'red'}}>
                                <FontAwesomeIcon icon={['far', 'circle']} />
                                <FontAwesomeIcon icon={['fas', 'caret-up']} transform="shrink-4 up-1" />
                            </span> Fulcrum
                        </a>
                    </>}
                </span>
            },
        ]
    }

    // eventIsScheduled(x) {
    //     return x.sampleEventTypeId === 1 && !(x.isComplete || x.finalizedDate);
    // }

    get DefaultSortColumn() { return "startDate"; }
    get DefaultSortAsc() { return false; }
}

export const service = new SampleEventService();

